import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { injectIntl, intlShape } from 'react-intl';
import { Container } from 'reactstrap';
import { Helmet } from 'react-helmet';
import Alert from 'react-s-alert';

import config from '../../config';
import { defaultLanguage } from '../../../Intl/setup';

// Import Style
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import 'react-datepicker/dist/react-datepicker.css';

// Import Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Loader from '../../components/Loader/Loader';

// Import Actions
import { initApp } from './AppActions';
import { getLoggedUser } from '../User/UserActions';
import { initLanguage, getCountryFromLanguage, getEnabledLanguages, getLanguagePath } from '../Intl/IntlActions';
import AppAnalytics from './components/stats/AppAnalytics';

let DevTools;
if(process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  DevTools = require('./components/DevTools').default;
}

export function App(props) {
    const canMount = props.isMounted || !process.env.CLIENT;

    return (
        <div id="wrapper">
            {false && canMount && !window.devToolsExtension && process.env.NODE_ENV === 'development' && <DevTools />}
            <Helmet
                htmlAttributes={{ lang: `${props.intl.locale}-${getCountryFromLanguage(props.intl.locale)}` }}
                defaultTitle={`${props.intl.formatMessage({ id: 'seoTitle', defaultMessage: config.application.seo.defaultTitle })} - ${config.application.name}`}
                titleTemplate={`%s - ${config.application.name}`}
                meta={[
                    { charset: 'utf-8' },
                    {
                        'http-equiv': 'X-UA-Compatible',
                        content: 'IE=edge',
                    },
                    {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1',
                    },
                ]}
                link={[
                    {
                        rel: 'canonical',
                        href: `${config.url}${props.location.pathname.substring(1)}`,
                    },
                ].concat(['/user/', '/orders/', '/address', '/cart/'].some(route => props.location.pathname.includes(route)) ? getEnabledLanguages().map(language => ({
                    rel: 'alternate',
                    href: `${config.url}${getLanguagePath(props.location.pathname, language).substring(1)}`,
                    hreflang: language,
                })).concat({
                    rel: 'alternate',
                    href: `${config.url}${getLanguagePath(props.location.pathname, defaultLanguage).substring(1)}`,
                    hreflang: 'x-default',
                }) : [])}
            />

            <div id="content-wrapper" className="app-wrapper d-flex flex-column">
                <div id="content">
                    <Header />

                    <Container fluid className="content-wrapper p-0">
                        <div className="content">
                            {
                                canMount
                                ? props.children
                                : <Loader />
                            }
                        </div>
                    </Container>

                    {canMount ? <Footer /> : null}
                </div>

                <Alert position="top-right" effect="flip" timeout={10000} stack={{ limit: 5 }} offset={30} />
                <AppAnalytics />
            </div>
        </div>
    );
}

App.defaultProps = {};

App.propTypes = {
  children: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  isMounted: PropTypes.bool.isRequired,
};

function mapStateToProps(store, props) {
    return {
        isMounted: store.app.isMounted,
        // user: getLoggedUser(store),
    };
}

App.need = [(params, store, query) => { return initLanguage(params.lang || query.lang, null, store); }, (params, store, query) => { return initApp(true); }];

export default connect(mapStateToProps)(withRouter(injectIntl(App)));
